import styled from 'styled-components';

export const AspectRatioBox = styled.div`
  position: relative;
  height: 0;
  width: 100%;
  padding-bottom: calc(0.75 * 100%);
`;

export const ScreenshotImage = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: contain;
  touch-action: pan-y;
`;
